import React, { useState, useContext } from "react";
import { Container, Nav, Tab, Alert, Spinner } from "react-bootstrap";
import {
  FaChartLine,
  FaLock,
  FaClock,
  FaUsers,
  FaUmbrellaBeach,
  FaChartPie,
} from "react-icons/fa";
import Navbar from "../components/Navbar";
import AppBreadcrumb from "../components/AppBreadcrumb";
import Sidebar from "../components/Sidebar";
import { AuthContext } from "../context/AuthContext";
import { useStatsDashboard } from "../components/statistiques/useStatsDashboard";
import StatsFiltersBar from "../components/statistiques/StatsFiltersBar";
import StatsTabSynthese from "../components/statistiques/StatsTabSynthese";
import StatsTabPaie from "../components/statistiques/StatsTabPaie";
import StatsTabEvolution from "../components/statistiques/StatsTabEvolution";
import StatsTabRecents from "../components/statistiques/StatsTabRecents";
import StatsTabEffectifs from "../components/statistiques/StatsTabEffectifs";
import StatsTabConges from "../components/statistiques/StatsTabConges";
import "./StatistiquesPage.css";
import "../components/statistiques/statsChartSetup";

const TABS = [
  { key: "synthese", label: "Synthèse paie", icon: <FaChartPie /> },
  { key: "paie", label: "Verrouillé / Ouvert", icon: <FaLock /> },
  { key: "evolution", label: "Évolution", icon: <FaChartLine /> },
  { key: "recents", label: "Nouveautés", icon: <FaClock /> },
  { key: "effectifs", label: "Effectifs", icon: <FaUsers /> },
  { key: "conges", label: "Congés", icon: <FaUmbrellaBeach /> },
];

const StatistiquesPage = () => {
  const { role } = useContext(AuthContext);
  const [activeKey, setActiveKey] = useState("synthese");

  const allowedRoles = ["RH", "ADMIN", "ASSISTANT"];
  const hasAccess = allowedRoles.includes(role);

  const {
    annee,
    setAnnee,
    mois,
    setMois,
    joursRecents,
    setJoursRecents,
    data,
    loading,
    error,
    refresh,
  } = useStatsDashboard();

  return (
    <div className="d-flex">
      <Sidebar />
      <div className="main-content">
        <Navbar />
        <Container fluid className="p-4 p-lg-5 stats-page-content">
          <AppBreadcrumb items={[{ label: "Accueil", to: "/" }, { label: "Statistiques" }]} />
          <div className="stats-page-header">
            <h4>Statistiques RH</h4>
            <p>
              Vue consolidée de la paie avec distinction verrouillé / non verrouillé,
              évolution mensuelle et saisies récentes.
            </p>
          </div>

          {!hasAccess ? (
            <Alert variant="danger">
              Vous n&apos;avez pas l&apos;autorisation d&apos;accéder à cette page.
            </Alert>
          ) : (
            <>
              <StatsFiltersBar
                annee={annee}
                setAnnee={setAnnee}
                mois={mois}
                setMois={setMois}
                joursRecents={joursRecents}
                setJoursRecents={setJoursRecents}
                onRefresh={refresh}
                loading={loading}
              />

              <div className="stats-tabs-surface">
                <Nav
                  variant="pills"
                  className="stats-nav-pills"
                  activeKey={activeKey}
                  onSelect={(k) => k && setActiveKey(k)}
                >
                  {TABS.map((t) => (
                    <Nav.Item key={t.key}>
                      <Nav.Link eventKey={t.key}>
                        {t.icon} {t.label}
                      </Nav.Link>
                    </Nav.Item>
                  ))}
                </Nav>
              </div>

              <div className="stats-main-panel">
                {loading && !data ? (
                  <div className="stats-loading">
                    <Spinner animation="border" />
                    <p className="mb-0 mt-2">Calcul des indicateurs…</p>
                  </div>
                ) : error ? (
                  <Alert variant="danger">{error}</Alert>
                ) : (
                  <>
                    {loading && (
                      <div className="text-end mb-2">
                        <Spinner animation="border" size="sm" className="text-primary" />
                        <span className="ms-2 small text-muted">Mise à jour…</span>
                      </div>
                    )}
                    {activeKey === "synthese" && <StatsTabSynthese data={data} />}
                    {activeKey === "paie" && <StatsTabPaie data={data} />}
                    {activeKey === "evolution" && <StatsTabEvolution data={data} />}
                    {activeKey === "recents" && (
                      <StatsTabRecents data={data} joursRecents={joursRecents} />
                    )}
                    {activeKey === "effectifs" && (
                      <StatsTabEffectifs active={activeKey === "effectifs"} />
                    )}
                    {activeKey === "conges" && (
                      <StatsTabConges active={activeKey === "conges"} annee={annee} />
                    )}
                  </>
                )}
              </div>
            </>
          )}
        </Container>
      </div>
    </div>
  );
};

export default StatistiquesPage;
